import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class Webmail extends MongoEntity {
  static override _class = 'Webmail';
  static override _collectionName = 'webmails';

  @validate(nonOptional())
  @Field(type => String)
  subject!: string;

  @validate(nonOptional())
  @Field(type => String)
  html!: string;

  @validate(nonOptional())
  @Field(type => [String])
  recipients!: string[];

  constructor(data: PartialEntityData<Webmail>) {
    super(data);
  }
}
